import { useState } from "react";
import { CopyIcon } from "vega-icons";

import { useClipboard } from "@vega-core/hooks/useClipboard";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { InteractiveButton } from "../InteractiveButton";
import { ThemedButton } from "../ThemedButton";

type Props = {
  email: string;
  label?: string;
  withCopy?: boolean;
  className?: string;
};

export const EmailTextButton = ({
  email,
  withCopy,
  label,
  className,
}: Props) => {
  const { copy } = useClipboard({ name: m.form_email(), withToast: true });
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!copied) {
      copy(email);
      setCopied(true);
    }
  };

  return (
    <div
      className="inline-flex items-center gap-2 text-text/secondary"
      data-testid="email-text-button"
    >
      <InteractiveButton
        ariaLabel={`Send an email to ${email}`}
        className={cnTwMerge("h-auto min-h-0", className)}
        dataTestId="send-email-button"
        route={`mailto:${email}`}
        variant="text"
      >
        {label ?? email}
      </InteractiveButton>
      {isTruthy(withCopy) && (
        <ThemedButton
          ariaLabel="Copy email to clipboard"
          className="p-0 min-h-0 h-6"
          dataTestId="copy-button"
          icon={<CopyIcon />}
          onClick={handleCopy}
          variant="tertiary"
        />
      )}
    </div>
  );
};
